export const Constants = {
  FoodSize: 36,
  FoodSpeed: -300,
  JunkProbability: 0.2,

  // Physics constants in proper units
  Gravity: 1000, // pixels/second² (acceleration)
  JumpImpulse: -6000, // pixels/second (instant velocity change)
  MaxFallSpeed: 800, // pixels/second (terminal velocity)
  GroundY: 300, // y-position of ground (GameHeight - 100)

  GameHeight: 400,
  GameWidth: 800,
};
